import type { JSX } from 'solid-js'

export function Sprout(props: JSX.SvgSVGAttributes<SVGSVGElement>) {
  return (
    <svg
      width="23"
      height="21"
      viewBox="0 0 23 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      {...props}
    >
      <path
        d="M18.0254 5.01127C19.3381 4.94503 20.6511 5.15082 21.8809 5.61478C22.3334 5.78556 22.5993 6.25631 22.5117 6.73197C22.2765 8.00653 21.7861 9.22109 21.0713 10.3023C20.3565 11.3834 19.4311 12.3092 18.3506 13.0249C18.3237 13.0428 18.2961 13.0596 18.2676 13.0747C17.1454 13.6699 15.9092 14.02 14.6416 14.1021C13.4973 14.1761 12.3511 14.0282 11.2637 13.6714C10.1765 14.028 9.03082 14.1761 7.88674 14.1021C6.61918 14.02 5.38292 13.6699 4.26076 13.0747C4.23222 13.0596 4.20372 13.0428 4.17678 13.0249C3.09647 12.3092 2.17074 11.3833 1.45608 10.3023C0.741392 9.22114 0.251873 8.00645 0.0166221 6.73197C-0.0708917 6.25644 0.194171 5.78566 0.646505 5.61478C1.87628 5.15069 3.18921 4.9451 4.50197 5.01127C5.65075 5.06923 6.7787 5.33493 7.83108 5.79252L8.27736 5.99955L8.38869 6.06498C9.46831 6.78892 10.3751 7.74239 11.044 8.85697C11.1208 8.98501 11.1936 9.11517 11.2637 9.24662C11.3338 9.11503 11.4075 8.98514 11.4844 8.85697C12.1533 7.74234 13.06 6.78894 14.1397 6.06498L14.251 5.99955C15.4277 5.41415 16.7128 5.07759 18.0254 5.01127Z"
        fill="#306E57"
      />
    </svg>
  )
}
